export const tableResponsive = (content) => {
	const tblRes = document.createElement("div");
	tblRes.classList.add("article-parse");
	tblRes.innerHTML = content;
	const tableList = tblRes.querySelectorAll("table");
	for (const tbl of tableList) {
		const divResponsive = document.createElement("div");
		divResponsive.classList.add("table-responsive");
		const parent = tbl.parentElement;
		parent.insertBefore(divResponsive, tbl);
		tbl.removeAttribute("border");
		tbl.removeAttribute("cellpadding");
		tbl.removeAttribute("cellspacing");
		tbl.removeAttribute("align");
		tbl.removeAttribute("style");
		tbl.setAttribute("class", "table aim--edit");
		divResponsive.append(tbl);
	}
	return tblRes;
};
